import { AxiosInstance } from 'axios';
import CountryList, { ICountryList_Item } from '@/modules/Country/List';

export default class CalendarApi {
  _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  async GetRentedAmount(fromDate?: string, fromTime?: string, toDate?: string, toTime?: string, rentalTypeId?: number, rentalObjectId?: number, leaseId?: number, customerId?: number, customerProject?: number): Promise<number | null> {
    const res = await this._client.get(
      '/Hyrma/Calendar/GetRentedAmount',
      { params: { fromDate, fromTime, toDate, toTime, rentalType: rentalTypeId, rentalObject: rentalObjectId, lease: leaseId, customer: customerId, customerProject } }
    );

    return res.data.data.rentedAmount;
  }
}